import type { GetOwnerCreditResponse } from "wagAPI";
import type { OwnerCreditParsedResponse } from "webApp";
export const getOwnerCreditResponseParser = (response: GetOwnerCreditResponse): OwnerCreditParsedResponse => ({
  creditBalance: response.balance || 0,
  temporaryCreditBalance: response.temporary_credit_balance || 0,
  pastDueBalance: response.past_due_info.past_due
});
export default getOwnerCreditResponseParser;